/**
 * Normalized entity id for roles/tabs (supports both 'id' and '_id' from API)
 */
export const getEntityId = (obj) => obj?.id ?? obj?._id;

/**
 * Returns user's role ID from login response.
 * Handles both shapes: { user: { role_id } } and { user: { user: { role_id } } } (full login response).
 */
export const getUserRoleId = (userObj) => {
  if (!userObj?.user) return undefined;
  const u = userObj.user?.user ?? userObj.user;
  return u.role !== undefined ? u.role : u.role_id;
};

/** Role id for SUPER_ADMIN (fallback when idRoleMap not yet loaded) */
const SUPER_ADMIN_ROLE_ID = 33;

/**
 * Returns whether the user has SUPER_ADMIN role (id 33 or name "SUPER_ADMIN").
 * Uses idRoleMap from getRoles when available; falls back to role_id === 33 so
 * Roles/Dashboard Management links show even before getRoles completes.
 */
export const isSuperAdmin = (userObj, idRoleMap = {}) => {
  if (!userObj?.user) return false;
  const roleId = getUserRoleId(userObj);
  if (roleId == null) return false;
  const map = idRoleMap && typeof idRoleMap === "object" ? idRoleMap : {};
  const name = map[roleId] ?? map[String(roleId)];
  const fromMap = name === "SUPER_ADMIN";
  const fallback = roleId === SUPER_ADMIN_ROLE_ID || roleId === String(SUPER_ADMIN_ROLE_ID);
  return fromMap || fallback;
};

/**
 * Returns Authorization header with Bearer token from localStorage (login response)
 */
export const getAuthHeaders = () => {
  try {
    const user = localStorage.getItem("user");
    if (!user) return {};
    const parsed = JSON.parse(user);
    const token = parsed.token;
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
  } catch (e) {}
  return {};
};
